// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"f88d262b","152":"72885f45","169":"bf21b48d","505":"ab9f393f","517":"727497db","631":"12a11217","928":"7dde4dd9"}[chunkId] + ".chunk.css";
};